export interface NewResults {
  ID: string;
  UID: string;
  Title: string;
  Duration: number;
  Deleted: boolean;
  DateCreated: Date;
  Initiator: Initiator;
  Results: Results;
  // Feedback: Feedback;
  Public: boolean;
  AudioFileURL: string;
  VideoFileURL: string;
  Errors: string | null;
}

export interface Results {
  totalScore: number;
  displayCategories: string[];
  summary: Summary;
  details: Details;
  transcript: string;
  wordStartTimes: number[];
  wordEndTimes: number[];
  duration: number;
  audioFileURL: string;
  videoFileURL: string;
  error: string | null;
}

export interface Initiator {
  Type: string;
  ID: number;
}

export interface Details {
  conciseness: Conciseness;
  confidence: Confidence;
  clarity: Clarity;
  pace: Pace;
  fillers: Fillers;
  energy: Energy;
  expression: Expression;
}

export interface StatementsAndAudio {
  audio?: number[];
  statements: string;
}

export interface Clarity {
  score: number;
  coachingText: StatementsAndAudio;
  transcriptHighlightLayers: TranscriptHighlightLayer[];
}

export interface Pace {
  score: number;
  overTime: number[];
  avg: number;
  variationGraph: Variation[];
  transcriptHighlightLayers: TranscriptHighlightLayer[];
}

export interface TranscriptHighlightLayer {
  title: string;
  segments: Segment[];
}

export interface Segment {
  startIndex: number;
  endIndex: number;
}

export interface Conciseness {
  score: number;
  totalSentences: number;
  repetition: ConcisenessRepetition;
  directness: ConcisenessDirectness;
  sentenceLengthDistribution: SentenceLengthDistribution;
  coachingText: StatementsAndAudio;
  transcriptHighlightLayers: TranscriptHighlightLayer[];
}

export interface ConcisenessDirectness {
  unnecessaryWordsAndPhrases: any[];
  passiveVoicePhrases: any[];
}

export interface ConcisenessRepetition {
  repeatedWords: any[];
  affectedSentences: number;
}

export interface SentenceLengthDistribution {
  averageLength: number;
  scale: number[];
  values: number[];
}

export interface Confidence {
  score: number;
  uncertaintyPhrases: UncertaintyPhrase[];
  fillerWordPercentage: number;
  awkwardPausesCount: number;
  coachingText: StatementsAndAudio;
  transcriptHighlightLayers: TranscriptHighlightLayer[];
}

export interface UncertaintyPhrase {
  phrase: string;
  count: number;
}

export interface Energy {
  score: number;
  pitch: Pitch;
  volume: Pitch;
  coachingText: StatementsAndAudio;
  transcriptHighlightLayers: TranscriptHighlightLayer[];
}

export interface Pitch {
  range: Range;
  variation: Variation[];
}

export interface Range {
  range: number;
  totalPossible: number;
}

export enum Variation {
  Bad = "bad",
  Good = "good",
  Medium = "medium",
  Nan = "nan"
}

export interface Fillers {
  score: number;
  fillerWords: any[];
  coachingText: StatementsAndAudio;
  transcriptHighlightLayers: TranscriptHighlightLayer[];
}

export interface Summary {
  categoriesToWorkOn: BestCategory[];
  bestCategory: BestCategory;
  coachingText: string;
}

export interface BestCategory {
  category: string;
  score: number;
  expression?: string;
}

export interface Expression {
  primary: ExpressionType;
  overTime: OverTime[];
  coachingText: StatementsAndAudio;
}

export interface OverTime {
  startTime: number;
  endTime: number;
  emotion: ExpressionType;
}

export enum ExpressionType {
  Neutral = "neutral",
  Positive = "positive",
  Negative = "negative",
}